module.exports = __webpack_public_path__ + "media/components/assets/icons/heart_empty-c3eb521178412cf5a518b6f06b5aa0e8.svg";